import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { forumThreads } from "@/mocks/forum";

export default function ForumTopics() {
  const items = forumThreads.slice(0, 5);

  return (
    <section>
      <SectionHeading
        icon="ri-chat-smile-2-line"
        title="社区热门话题"
        desc="与同好一起畅聊，分享你的观点与发现"
        actionTo="/forum"
        actionLabel="进入社区"
      />

      <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
        {items.map((thread) => (
          <Link
            key={thread.id}
            to={`/forum/thread/${thread.id}`}
            className="group flex items-start gap-3 px-4 py-4 transition-colors hover:bg-background-50 md:px-5"
          >
            <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-chat-3-line text-base" aria-hidden="true"></i>
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                {thread.title}
              </h3>
              <div className="mt-1.5 flex flex-wrap items-center gap-3 text-xs text-foreground-400">
                <span>{thread.author}</span>
                <span>
                  <i className="ri-reply-line mr-1 align-middle" aria-hidden="true"></i>
                  {thread.replies} 回复
                </span>
                <span className="hidden sm:inline">{thread.lastReply}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}